import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Card, CardContent, Button } from '@mui/material';
import SeminalFluidAnalysis from './seminalFluidAnalysis';
import PostWashAnalysis from './postWashAnalysis';
import PatientDetails from './patientDetails';
import SemenAnalysis from './semenAnalysis';
import { styled } from '@mui/system';
import OtherDetails from './otherDetails';
import SpermDFIAnalysis from './spermDFIAnalysis';
import QualityAnalysis from './qualityAnalysis';
import DfiDetails from './dfiDetails';
import { useDispatch, useSelector } from 'react-redux';
import {
  createDFIReport,
  generateDFIReport,
  updateDFIReport,
} from '../../../../api/andrologyApi';
import {
  resetAndrologyData,
  setAndrologyData,
} from '../../../../actions/andrologyAction';
import axios from 'axios';
import { pollFileAvailability } from '../../../../api/utils';
import { checkFileAvailabilityApi } from '../../../../api/patientApi';
import { toast } from 'sonner';
import UIModal from '../../../../components/UIElements/UIModal';
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  borderRadius: '8px',
}));

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(3),
  border: '1px solid #ddd',
  borderRadius: '8px',
}));

export default function DfiReport({ setIsReportSelected }) {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const selectedPatientData = useSelector(
    (state) => state.andrologyReducer.selectedPatientData,
  );
  const dfiData = useSelector((state) => state.andrologyReducer.dfi);

  const dispatch = useDispatch();
  const handleSave = async () => {
    const res = await createDFIReport(selectedPatientData.patient.id, {
      ...dfiData,
      id: undefined,
    });
    dispatch(setAndrologyData('dfi', res.data));
  };

  const handleUpdate = async () => {
    const res = await updateDFIReport(selectedPatientData.patient.id, dfiData);
    dispatch(setAndrologyData('dfi', res.hsa));
  };

  const handleNext = () => {
    if (selectedTab < 5) {
      setSelectedTab((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (selectedTab > 0) {
      setSelectedTab((prev) => prev - 1);
    }
  };
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);

  const handleGenerateReport = async () => {
    setIsDownloadDisabled(true);
    const res = await generateDFIReport(
      selectedPatientData.patient.id,
      dfiData.id,
    );
    if (res && res.pdf && res.pdf.file) {
      // dispatch(resetAndrologyData());
      setIsDownloadDisabled(false);
      toast.success('Report Generated');

      try {
        const presignedUrl = await pollFileAvailability(
          checkFileAvailabilityApi,
          res.pdf.file.bucketName,
          res.pdf.file.fileKey,
        );
        dispatch(setAndrologyData('dfi.reportId', res.pdf.file.id));
        downloadFile(presignedUrl, selectedPatientData.patient.id);
        dispatch(setAndrologyData('refresh', true));
      } catch (error) {
        setIsDownloadDisabled(false);
        console.error('Failed to get presigned URL:', error);
      }
    }
  };

  const downloadFile = async (presignedUrl, patientId) => {
    try {
      const response = await axios.get(presignedUrl, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${patientId}-dfi-report.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  };

  const handleCancelStartReport = () => {
    setOpenConfirmModal(false);
  };

  const handleSaveAndNext = () => {
    if (!dfiData.id) {
      handleSave();
    } else {
      handleUpdate();
    }
    handleNext();
  };

  // on dfi image selection
  useEffect(() => {
    if (dfiData.id) {
      handleUpdate();
    }
  }, [dfiData.dfiDetails.dfiImagesToBeAttached]);

  return (
    <div className="theme-blush">
      <StyledCard>
        <CardContent>
          <StyledBox>
            <Tabs
              value={selectedTab}
              onChange={handleChange}
              aria-label="DFI Report Tabs"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Patient Details" />
              <Tab label="Seminal Fluid Analysis" />
              <Tab label="Sperm Analysis" />
              <Tab label="Quality Analysis" />
              <Tab label="DFI Details" />
              <Tab label="Other Details" />
              {/* <Tab label="Sperm DFI Analysis" /> */}
              {/* <Tab label="Semen Analysis" /> */}
              {/* <Tab label="Post Wash Analysis" /> */}
            </Tabs>
            <Box mt={2}>
              {selectedTab === 0 && (
                <PatientDetails keyPath={'dfi.patientDetails'} />
              )}
              {selectedTab === 1 && (
                <SeminalFluidAnalysis keyPath={'dfi.seminalFluidAnalysis'} />
              )}
              {selectedTab === 2 && (
                <SemenAnalysis keyPath={'dfi.spermAnalysis'} />
              )}
              {selectedTab === 3 && (
                <QualityAnalysis keyPath={'dfi.qualityAnalysis'} />
              )}
              {selectedTab === 4 && (
                <DfiDetails
                  keyPath={'dfi.dfiDetails'}
                  handleUpdate={handleUpdate}
                />
              )}
              {selectedTab === 5 && (
                <OtherDetails keyPath={'dfi.otherDetails'} />
              )}
              {/* {selectedTab === 4 && <SpermDFIAnalysis keyPath={'dfi.spermDfiAnalysis'}/>} */}
              {/* {selectedTab === 6 && <SemenAnalysis keyPath={'dfi.spermAnalysis'}/>} */}
              {/* {selectedTab === 7 && <PostWashAnalysis keyPath={'dfi.postWashAnalysis'}/>} */}
            </Box>
            <Box
              mt={4}
              display={'flex'}
              flexDirection={'row'}
              gap={'12px'}
              justifyContent={'end'}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setIsReportSelected(false);
                }}
                style={{ minWidth: '180px' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleBack}
                disabled={selectedTab === 0}
                style={{ minWidth: '180px' }}
              >
                Back
              </Button>
              {selectedTab != 5 ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save And Next
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveAndNext}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )}
              {/* {!dfiData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSave}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )}
              {dfiData.id && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUpdate}
                  style={{ minWidth: '180px' }}
                >
                  Save
                </Button>
              )} */}
              {selectedTab === 5 && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenConfirmModal(true)}
                  style={{ minWidth: '180px' }}
                  disabled={isDownloadDisabled}
                >
                  Generate Report
                </Button>
              )}
            </Box>
          </StyledBox>
        </CardContent>
      </StyledCard>
      <UIModal
        title="Please confirm?"
        body="Do you want to generate report? Report once generated can't be changed. Do you still want to go ahead?"
        proceedText="Confirm"
        cancelText="Cancel"
        show={openConfirmModal}
        onClose={() => handleCancelStartReport()}
        onSave={() => {
          handleGenerateReport();
          setOpenConfirmModal(false);
        }}
      />
    </div>
  );
}
